import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonIcon } from 'react-rainbow-components';
import CloseIcon from '../icons/close/index.js';
import MessageIcon from './icon';
import hideMessage from '../../redux/actions/app/hide-message';
import './styles.css';

function Message(props) {
    const {
        className,
        message,
        variant,
        hideMessage,
    } = props;

    function getClassName() {
        return classnames('scheduler-message_container', {
            'scheduler-message_container--shown': message,
        }, `scheduler-message_container-${variant}`, className);
    }

    return (
        <article data-cy="message" className={getClassName()}>
            <div className="scheduler-message_content">
                <MessageIcon variant={variant} />
                <p className="scheduler-message_text">
                    {message}
                </p>
                <ButtonIcon
                    id="message-close-button"
                    size="medium"
                    icon={<CloseIcon />}
                    onClick={hideMessage}
                    assistiveText="close message"
                    className="scheduler-message_close-button" />
            </div>
        </article>
    );
}

Message.propTypes = {
    className: PropTypes.string,
    message: PropTypes.node,
    variant: PropTypes.string,
    hideMessage: PropTypes.func.isRequired,
};

Message.defaultProps = {
    className: undefined,
    message: undefined,
    variant: 'error',
};

function stateToProps(state) {
    return {
        message: state.app.get('message'),
        variant: state.app.get('messageVariant'),
    };
}

function dispatchToProps(dispatch) {
    return bindActionCreators({
        hideMessage,
    }, dispatch);
}

export default connect(stateToProps, dispatchToProps)(Message);
